import { LotesRutas, GetHeaderRequest, GetResponseBody } from './RutasConfig';

export const Agregar_Inventario_Detalles_Lote_Request = async (pToken, pEmpresaId, pSucursalId, pBodega_Id, pMov_Id, pDetalles, pUsuario) => {
    const data = { Empresa_Id: pEmpresaId, Sucursal_Id: pSucursalId, Bodega_Id: pBodega_Id, Mov_Id: pMov_Id, Detalles: pDetalles, Usuario_Id: pUsuario };
    const result = await fetch(LotesRutas.Agregar_Inventario_Detalles_Lote, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};

export const Agregar_SubOrden_Detalles_Lote_Request = async (pToken, pEmpresaId, pSucursalId, pCallCenterId, pOrdenId, pDetalles) => {
    const data = { EmpresaId: pEmpresaId, SucursalId: pSucursalId, CallCenterId: pCallCenterId, OrdenId: pOrdenId, Detalles: pDetalles };
    const result = await fetch(LotesRutas.Agregar_SubOrden_Detalles_Lote, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};

export const Eliminar_SubOrden_Detalles_Lote_Por_Articulo_Request = async (pToken, pEmpresaId, pSucursalId, pCallCenterId, pOrdenId, pArticulo_Id) => {
    const data = { EmpresaId: pEmpresaId, SucursalId: pSucursalId, CallCenterId: pCallCenterId, OrdenId: pOrdenId, Articulo_Id: pArticulo_Id };
    const result = await fetch(LotesRutas.Eliminar_SubOrden_Detalles_Lote_Por_Articulo, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};

export const Obtener_Conexion_Lote_Request = async (pToken) => {
    const result = await fetch(LotesRutas.Obtener_Conexion_Lote, {
        method: 'GET',
        headers: GetHeaderRequest(pToken)
    });
    return await GetResponseBody(result);
};

export const Obtener_SubOrden_Detalles_Lote_Request = async (pToken, pEmpresaId, pSucursalId, pCallCenterId, pOrdenId) => {
    const data = { EmpresaId: pEmpresaId, SucursalId: pSucursalId, CallCenterId: pCallCenterId, OrdenId: pOrdenId };
    const result = await fetch(LotesRutas.Obtener_SubOrden_Detalles_Lote, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};